import { create } from "zustand";
import { createJSONStorage, persist } from 'zustand/middleware'

export const usePermitStore = create(
    persist(
        (set) => ({
            ExportBasicDetail : {},
            ExportExtentionDetail : undefined,
            ExportPermitImgDetail:undefined,
            ExportPermitImage : [],
            ExportPermitDetail : [],
            ExportPermitActivity : [],
            ExportPermitApproval : [],
            setExportBasicDetail: (Details) => set((state) => ({
                ...state,
                ExportBasicDetail: Details
            })
            ),
            setExportExtentionDetail: (Details) => set((state) => ({
                ...state,
                ExportExtentionDetail: Details
            })
            ),
            setExportPermitImgDetails :(Details) => set((state) =>({
                ...state,
                ExportPermitImgDetail: Details
            })),
            setExportPermitImages : (Details) => set((state)=>({
                ...state,
                ExportPermitImage: Details
            })),
            setExportPermitDetail:(Details) => set((state)=> ({
                ...state,
                ExportPermitDetail :Details
            })),
            setPermitActivity:(Details) => set((state) => ({
                ...state,
                ExportPermitActivity : Details
            })),
            setPermitApproval:(Details) => set((state) => ({
                ...state,
                ExportPermitApproval : Details
            }))
        }), {
        name: "Permit",
        storage: createJSONStorage(() => sessionStorage),
    }))